export default __webpack_public_path__ + "static/media/phrases_gray.ca4b8bfd.svg";